import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4 text-center">
            <h1 className="text-9xl font-extrabold text-[#113A6E] tracking-widest drop-shadow-md">404</h1>
            <div className="bg-orange-500 px-2 text-sm rounded rotate-12 absolute text-white font-bold drop-shadow">
                Page Not Found
            </div>
            <div className="mt-8">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                    Oops! The page you're looking for isn't here.
                </h3>
                <p className="text-gray-600 mb-8 max-w-md mx-auto">
                    You might have the wrong address, or the page may have moved.
                </p>
                <Link
                    to="/"
                    className="inline-block px-8 py-3 bg-[#113A6E] text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                    Return Home
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
